import _ from 'lodash'

export const getItemTotal = (item) => {
    const { quantity, basic_charge, basic_charge_quantity, unit_rate } = item

    if (quantity > 0 && basic_charge && basic_charge_quantity) {
        if (basic_charge_quantity >= quantity)
            return basic_charge
        else
            return basic_charge + (quantity - basic_charge_quantity) * unit_rate
    } else {
        return quantity * unit_rate || 0
    }
}

export const getSectionTotal = (itemList) => {
    let total = 0;

    _.map(itemList, (item, idx) => {
        if (!item.optional)
            total += getItemTotal(item)
    })

    return total
}

export const getGrandTotal = (type, sectionList, noticeSection, discounts) => {
    let total = 0;

    _.map(sectionList, (section, sectionIdx) => {
        total += getSectionTotal(section.items)
    })

    if (type === 'notice' || type === 'variation-order')
        total += getSectionTotal(noticeSection.items)

    _.map(discounts, (discount, discountIdx) => {
        total -= discount.amount
    })

    return total
}



// WEBPACK FOOTER //
// ./src/utils/totalCalculator.js